export default {
  heroHeadingTextTransform: 'uppercase',
  textCartConfirmationColor: Styles.color.black,
  cartConfirmationItemBorder: `1px solid ${Styles.color.grey.five}`,
  pickupInstructionsColor: Styles.color.black,
};
